import { ISMT_CauTrucDe_SelectRequest } from "../../../model/request/de-thi/ISMT_CauTrucDe_SelectRequest";
import { ISMT_CauTrucDeThi_Vm } from "../../../model/respone/de-thi/ISMT_CauTrucDeThi_Vm";
import { ISMT_ChonCauHoi_Vm } from "../../../model/respone/de-thi/ISMT_ChonCauHoi_Vm";
import { ICauTrucDeThiActionTypes } from "../../action-types/de-thi/ICauTrucDeThiActions";
import { ICauTrucDeThiReducer } from "../../reducer-model/de-thi/ICauTrucDeThiReducer";

import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ICauTrucDeThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  cauTrucDeThiEditing: {} as ISMT_CauTrucDeThi_Vm,
  cauTrucDeThis: [],
  chonCauHoi: [],
  chonCauHoiEditing: {} as ISMT_ChonCauHoi_Vm,
  sectionData: [],
  request: {
    id_mons: [],
    id_he: 0,
    id_bm: 0,
  } as ISMT_CauTrucDe_SelectRequest,
};

export const cauTrucDeThiReducer = (
  state: ICauTrucDeThiReducer = iniState,
  action: ICauTrucDeThiActionTypes
): ICauTrucDeThiReducer => {
  switch (action.type) {
    case "CAU_TRUC_DE_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CAU_TRUC_DE_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        cauTrucDeThis: action.payload,
      };
    case "CAU_TRUC_DE_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_TRUC_DE_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CAU_TRUC_DE_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        cauTrucDeThiEditing: undefined,
        sectionData: [],
        isShowEditModal: false,
      };
    case "CAU_TRUC_DE_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_TRUC_DE_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CAU_TRUC_DE_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CAU_TRUC_DE_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_TRUC_DE_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        cauTrucDeThiEditing: action.payload
          ? {
              ...action.payload,
              // cauTrucDe: (action.payload as any).cauTrucDe ?? {},
              section: (action.payload as any).section ?? [],
            }
          : undefined,
        isShowEditModal: true,
      };
    case "CAU_TRUC_DE_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        cauTrucDeThiEditing: undefined,
        isShowEditModal: false,
      };
    case "CAU_TRUC_DE_THI_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "CAU_TRUC_DE_THI_LOAD_START_CHON_CAU_HOI":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CAU_TRUC_DE_THI_LOAD_SUCCESS_CHON_CAU_HOI":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chonCauHoi: action.payload,
      };
    case "CAU_TRUC_DE_THI_LOAD_ERROR_CHON_CAU_HOI":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };

    case "CAU_TRUC_DE_THI_SHOW_CHON_CAU_HOI_MODAL":
      return {
        ...state,
        chonCauHoiEditing: action.payload,
        status: eReducerStatusBase.is_completed,
        isShowChonCauHoiModal: true,
      };
    case "CAU_TRUC_DE_THI_CLOSE_CHON_CAU_HOI_MODAL":
      return {
        ...state,
        chonCauHoiEditing: undefined,
        isShowChonCauHoiModal: false,
      };

    case "CAU_TRUC_DE_THI_LOAD_SECTION_DATA_START":
      return {
        ...state,
      };
    case "CAU_TRUC_DE_THI_LOAD_SECTION_DATA_SUCCESS":
      return {
        ...state,
        sectionData: action.payload,
      };
    case "CAU_TRUC_DE_THI_LOAD_SECTION_DATA_ERROR":
      return {
        ...state,
      };
    case "CAU_TRUC_DE_THI_CLEAR_SECTION_DATA":
      return {
        ...state,
        sectionData: [],
      };
    case "CAU_TRUC_DE_THI_DELETE_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CAU_TRUC_DE_THI_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "CAU_TRUC_DE_THI_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_TRUC_DE_THI_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
